"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _glamor = require("glamor");

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cf = function cf(path) {
  return __CLIENT__ && "https://d3uwib8iif8w1p.cloudfront.net/megascans/" + path || "";
};
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var para = (0, _glamor.css)(_fonts.p3, {
  color: _css.colors.gray
});

var jobContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "center"
});
var jobSubContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "2px solid #222",
  alignItems: "center",
  textAlign: "left",
  paddingTop: "1.625rem",
  paddingBottom: "1.625rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  maxWidth: 960
}), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  minWidth: 700
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  minWidth: 650
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  minWidth: 450
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  minWidth: 350
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  minWidth: 271
}));
var containerSection = (0, _glamor.css)({
  flexBasis: "50%"
});
var containerSectionL = (0, _glamor.css)({
  flexBasis: "66%"
});
var containerSectionR = (0, _glamor.css)({
  flexBasis: "34%"
});

var headingRow = (0, _glamor.css)({
  marginTop: "3rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: "6rem"
}));

var label = (0, _glamor.css)(_fonts.subH2, {
  letterSpacing: "unset",
  textTransform: "uppercase"
});

var Jobs = function (_React$Component) {
  (0, _inherits3.default)(Jobs, _React$Component);

  function Jobs(props) {
    (0, _classCallCheck3.default)(this, Jobs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Jobs.__proto__ || (0, _getPrototypeOf2.default)(Jobs)).call(this, props));

    _this.renderHeader = function () {
      return _react2.default.createElement(_components.Hero, {
        className: (0, _glamor.css)({ "& h3": { textTransform: "uppercase" } }),
        bg: cf_utils.cf_qx_page("about", "quixel-about-herovideo-fallback.jpeg"),
        opacity: 0.25,
        backgroundVideo: {
          poster: cf_utils.cf_qx_page("about", "quixel-about-herovideo-fallback.jpeg"),
          loop: "true",
          src: cf_utils.cf_qx_page("about", "Quixel-About-Herovideo.mp4")
        },
        superIconUrls: [cf("home/quixel_2080_logo.png")],
        title: "join our team",
        subTitle: "We hire passionate people, and give them the autonomy to do great work.",
        primaryLabel: "",
        primaryTo: ""
      });
    };

    _this.renderContent = function () {
      return _react2.default.createElement(_Section2.default, {
        innerClassName: (0, _glamor.css)({ marginBottom: "4.5rem" }),
        subHeading: "work at quixel",
        title: "open positions",
        headingBeforeBreak: "We hire creative, passionate people,",
        headingAfterBreak: "and give them the autonomy to do great work.",
        content: _this.renderJobs()
      });
    };

    _this.renderJobs = function () {
      var _this$state = _this.state,
          jobs = _this$state.jobs,
          loaded = _this$state.loaded;


      var output = null;
      if (loaded) {
        output = (0, _keys2.default)(jobs).map(function (key, index) {
          return _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)(jobContainer) },
            _react2.default.createElement(
              "div",
              { className: containerSection },
              _react2.default.createElement(
                "div",
                { className: (0, _glamor.css)(jobSubContainer, index !== 0 && headingRow) },
                _react2.default.createElement(
                  "div",
                  { className: containerSectionL },
                  _react2.default.createElement(
                    "span",
                    { className: label },
                    "" + jobs[key].title
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: containerSectionR },
                  _react2.default.createElement(
                    "span",
                    { className: label },
                    "LOCATION"
                  )
                )
              ),
              jobs[key].postings.map(function (v) {
                return _react2.default.createElement(
                  "div",
                  { className: jobSubContainer },
                  _react2.default.createElement(
                    "div",
                    { className: containerSectionL },
                    _react2.default.createElement(_components.TextButtonLibrary, {
                      className: (0, _glamor.css)({
                        padding: 0,
                        fontWeight: "400",
                        fontSize: "18px",
                        textTransform: "capitalize"
                      }),
                      href: v.hostedUrl,
                      newWindow: true,
                      label: v.text
                    })
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: containerSectionR },
                    _react2.default.createElement(
                      "span",
                      { className: para },
                      v.categories.location
                    )
                  )
                );
              })
            )
          );
        });
      } else {
        output = _react2.default.createElement(
          "div",
          {
            className: (0, _glamor.css)(jobContainer, {
              marginTop: "6rem",
              marginBottom: "6rem"
            })
          },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }
      return output;
    };

    _this.state = {
      loading: false,
      loaded: false,
      error: null,
      jobs: {}
    };
    return _this;
  }

  (0, _createClass3.default)(Jobs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({ loading: true });

      var getMetaData = function getMetaData(name, metadata) {
        var dep = metadata.filter(function (meta) {
          return meta.name === name;
        }).shift();
        return dep && dep.value;
      };

      var getLocation = function getLocation(offices, isRemotely) {
        if (Array.isArray(offices) && offices.length > 0) {
          var office = offices.find(function (x) {
            return x !== undefined;
          }); //Always gets first element
          return office && office.name + (isRemotely ? "/Flexible" : "");
        }
        return "";
      };

      var formateJob = function formateJob(job) {
        var obj = {};
        var offices = job.offices,
            title = job.title,
            absolute_url = job.absolute_url,
            metadata = job.metadata;


        var isRemotely = metadata && getMetaData("Careers Page Remote Eligible", metadata) === "Yes";

        var location = offices && getLocation(offices, isRemotely);

        var department = metadata && getMetaData("Careers Page Department", metadata);

        if (!obj[department]) {
          obj[department] = {};
          obj[department]["postings"] = [];
          obj[department].title = department;
        }

        obj[department]["postings"].push({
          categories: {
            location: location,
            team: department
          },
          text: title,
          hostedUrl: absolute_url
        });
        return obj;
      };

      var filterAndMerge = function filterAndMerge(list, toBeMergedList) {
        for (var prop in list) {
          //find object with same props
          var find = _ramda2.default.find(_ramda2.default.propEq("title", prop))(toBeMergedList);
          if (find) {
            //merge both objects postings from jobs list and GreenHouse object list
            var concatPositions = function concatPositions(k, l, r) {
              return k == "postings" ? _ramda2.default.concat(r, l) : r;
            };
            var mergeAll = _ramda2.default.mergeWithKey(concatPositions, find, list[prop]);
            //find index and replace merged object
            toBeMergedList[_ramda2.default.findIndex(_ramda2.default.propEq("title", prop))(toBeMergedList)] = mergeAll;
          } else {
            //push GreenHouse object posting to jobs
            toBeMergedList.push(list[prop]);
          }
        }
        return toBeMergedList;
      };

      _axios2.default.get("https://api.lever.co/v0/postings/quixel?group=team&mode=json").then(function (response) {
        // handle success
        var jobsListing = response.data;

        _axios2.default.get("https://boards-api.greenhouse.io/v1/boards/quixel/jobs?content=true").then(function (_ref) {
          var jobs = _ref.data.jobs;

          var mergedList = jobsListing || [];
          jobs.map(function (job) {
            var formatedJob = formateJob(job);

            mergedList = filterAndMerge(formatedJob, jobsListing);
          });
          _this2.setState({
            loading: false,
            loaded: true,
            jobs: mergedList,
            error: null
          });
        });
      }).catch(function (error) {
        // handle error
        console.log(error);
        _this2.setState({ loading: false, error: error, jobs: {} });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Jobs - Be a part of the 3D revolution",
          documentImage: cloudfrontThumbs("page-thumb-jobs.jpg"),
          documentDescription: "Join our growing team of passionate, amazing people who are working together to create the best 3D content library the world has ever seen."
        },
        _react2.default.createElement(
          "div",
          null,
          this.renderHeader(),
          this.renderContent()
        )
      );
    }
  }]);
  return Jobs;
}(_react2.default.Component);

exports.default = Jobs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Jobs/Jobs.jsx
// module id = 2926
// module chunks = 0